export default {
  HEADER_FIL: "Header_Fil",
  MOBILE_HEADER_FIL: "Mobile_Header_Fil",
  HP_PRODUITS: 'HP_Produits',
  HP_BOUTIQUE_MEA_1: 'HP_Boutique_MEA_1',
  HP_BOUTIQUE_MEA_2: 'HP_Boutique_MEA_2',
  MOBILE_HP_BOUTIQUE_MEA_1: 'Mobile_HP_Boutique_MEA_1',
  MOBILE_HP_BOUTIQUE_MEA_2: 'Mobile_HP_Boutique_MEA_2',
  HP_BOUTIQUE_PRODUITS_1: 'HP_Boutique_Produits_1',
  HP_BOUTIQUE_PRODUITS_2: 'HP_Boutique_Produits_2',
  HP_POPIN: 'HP_Popin',
  MOBILE_HP_POPIN: 'Mobile_HP_Popin',
  HP_MEA_MAGASIN: 'HP_MEA_Magasin',
  MOBILE_HP_MEA_MAGASIN: 'Mobile_HP_MEA_Magasin',
  HP_SLIDER: 'HP_Slider',
  HP_SLIDER_MOBILE: 'Mobile_HP_Slider',
  HP_DROITE_SLIDER: 'HP_Droite_Slider',
  MOBILE_HP_DROITE_SLIDER: 'Mobile_HP_Droite_Slider',
  HP_BAS_SLIDER: 'HP_Bas_Slider',
  MOBILE_HP_BAS_SLIDER: 'Mobile_HP_Bas_Slider',
  HP_MEA_HAUT: 'HP_MEA_Haut',
  MOBILE_HP_MEA_HAUT: 'Mobile_HP_MEA_Haut',
  HP_MEA_HAUT_2: 'HP_MEA_Haut_2',
  MOBILE_HP_MEA_HAUT_2: 'Mobile_HP_MEA_Haut_2',
  HP_MEA_BAS: 'HP_MEA_Bas',
  MOBILE_HP_MEA_BAS: 'Mobile_HP_MEA_Bas',
  HP_BANDEAU_FULL: 'HP_Bandeau_Full',
  PRO_HP_SLIDER: 'Pro_HP_Slider',
  PRO_HP_DROITE_SLIDER: "Pro_HP_Droite_Slider",
  PRO_HP_BAS_SLIDER: "Pro_HP_Bas_Slider",
  PRO_HP_PRODUITS: "Pro_HP_Produits",
  PRO_MOBILE_HP_SLIDER: 'Pro_Mobile_HP_Slider',
  PRO_MOBILE_HP_DROITE_SLIDER: "Pro_Mobile_HP_Droite_Slider",
  PRO_MOBILE_HP_BAS_SLIDER: "Pro_Mobile_HP_Bas_Slider"
}
